import React, { useMemo } from 'react';
import { Breadcrumbs, Link, Typography } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { useThemeMode } from '../providers/ThemeModeProvider';
import { getAppBreadcrumbs } from '../navigation/getAppBreadcrumbs';

export default function AppBreadcrumbs() {
  const location = useLocation();
  const { darkState } = useThemeMode();
  const crumbs = useMemo(() => getAppBreadcrumbs(location.pathname), [location.pathname]);

  if (crumbs.length === 0) {
    return null;
  }

  const accentColor = darkState ? 'secondary.main' : 'primary.main';

  return (
    <Breadcrumbs
      aria-label="Fil d'Ariane"
      separator={
        <NavigateNextIcon
          fontSize="small"
          sx={{ color: 'text.disabled', mx: 0.25, flexShrink: 0 }}
        />
      }
      maxItems={4}
      itemsBeforeCollapse={1}
      itemsAfterCollapse={1}
      sx={{
        flex: 1,
        minWidth: 0,
        '& .MuiBreadcrumbs-ol': {
          flexWrap: 'nowrap',
        },
        '& .MuiBreadcrumbs-li': {
          minWidth: 0,
          maxWidth: { xs: 140, sm: 220, md: 280 },
        },
      }}
    >
      {crumbs.map((crumb, index) => {
        const isLast = index === crumbs.length - 1;

        if (isLast || !crumb.path) {
          return (
            <Typography
              key={`${crumb.label}-${index}`}
              variant="body2"
              noWrap
              sx={{
                fontWeight: 600,
                color: isLast ? 'text.primary' : 'text.secondary',
              }}
            >
              {crumb.label}
            </Typography>
          );
        }

        return (
          <Link
            key={crumb.path}
            component={RouterLink}
            to={crumb.path}
            variant="body2"
            underline="hover"
            noWrap
            sx={{
              fontWeight: 500,
              color: accentColor,
              '&:hover': {
                color: darkState ? 'secondary.light' : 'primary.light',
              },
            }}
          >
            {crumb.label}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
}
